import React from 'react';
import type { Clasificacion, EstadoExpediente, Materia } from '../../types';
const COLOR_MATERIA: Record<Materia, string> = {
  Penal: 'bg-marino-800 text-white',
  Civil: 'bg-marino-100 text-marino-800',
  Mercantil: 'bg-gris-200 text-gris-700',
  Laboral: 'bg-ambar-50 text-ambar-700 ring-1 ring-ambar-100',
  Familiar: 'bg-exito-50 text-exito-700 ring-1 ring-exito-100',
  Administrativo: 'bg-marino-50 text-marino-600 ring-1 ring-marino-100',
  Amparo: 'bg-peligro-50 text-peligro-700 ring-1 ring-peligro-100'
};
export function ChipMateria({
  materia
}: {
  materia: Materia;
}) {
  return <span className={`inline-flex items-center rounded px-2 py-0.5 text-2xs font-semibold uppercase tracking-wide ${COLOR_MATERIA[materia]}`} data-id="element-908" data-mp="242ei8e6x5ssb">
      {materia}
    </span>;
}
const COLOR_ESTADO: Record<EstadoExpediente, string> = {
  Activo: 'text-exito-700 bg-exito-50 ring-exito-100',
  Archivado: 'text-gris-600 bg-gris-100 ring-gris-200',
  Concluido: 'text-marino-700 bg-marino-50 ring-marino-100'
};
export function ChipEstado({
  estado
}: {
  estado: EstadoExpediente;
}) {
  return <span className={`inline-flex items-center rounded px-2 py-0.5 text-2xs font-medium ring-1 ${COLOR_ESTADO[estado]}`} data-id="element-909" data-mp="3cen6xsqve5qs">
      {estado}
    </span>;
}
const COLOR_CLASIFICACION: Record<Clasificacion, string> = {
  Público: 'bg-gris-100 text-gris-700 ring-gris-200',
  Privado: 'bg-marino-800 text-white ring-marino-800',
  'Copia certificada': 'bg-ambar-50 text-ambar-700 ring-ambar-100'
};
export function ChipClasificacion({
  clasificacion
}: {
  clasificacion: Clasificacion;
}) {
  return <span className={`inline-flex items-center rounded px-2 py-0.5 text-2xs font-medium ring-1 ${COLOR_CLASIFICACION[clasificacion]}`} data-id="element-910" data-mp="3z3id7159bi2">
      {clasificacion}
    </span>;
}
const TAMANO_AVATAR = {
  sm: 'h-7 w-7 text-2xs',
  md: 'h-10 w-10 text-xs',
  lg: 'h-16 w-16 text-base'
};
export function Avatar({
  iniciales,
  tono = 'marino',
  foto,
  tamano = 'sm',
  nombre
}: {
  iniciales: string;
  tono?: 'marino' | 'gris';
  foto?: string;
  tamano?: keyof typeof TAMANO_AVATAR;
  nombre?: string;
}) {
  if (foto) {
    return <img src={foto} alt={nombre ? `Foto de ${nombre}` : ''} className={`shrink-0 rounded-full object-cover ${TAMANO_AVATAR[tamano]}`} data-id="element-911" data-mp="1xs4vtoq03rmm" />;
  }
  return <span className={`inline-flex shrink-0 items-center justify-center rounded-full font-semibold ${TAMANO_AVATAR[tamano]} ${tono === 'marino' ? 'bg-marino-800 text-white' : 'bg-gris-200 text-gris-700'}`} aria-hidden="true" data-id="element-912" data-mp="27mws8p7uk8ft">
      {iniciales}
    </span>;
}